<template>
	<PopupRouterView :showLeftIcon="true" label="Approval Configuration Input" okTitle="Save" cancelTitle="Cancel"  entityName="approvalconfiguration" :documentId="mainRecordId"  @saveMethod="saveAction" @hideMethod="onHidden">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
					<app-input-textbox id="fieldset-name" label-cols-lg="12" label="Name" label-for="input-name" size="sm" :model.sync="model.name"  @change="updateData" />
					<app-input-combobox-autocomplete :options="approvalTypes" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Approval Type" id="input-" size="sm" :model.sync="model.approvalTypeId"  :selected="model.approvalType != null ? model.approvalType.name : ''" @input="getApprovalTypes" @change="updateData" :loading="isApprovalComboLoading"/>
					<app-input-textarea id="fieldset-description" label-cols-lg="12" label="Description" label-for="input-description" size="sm" :model.sync="model.description"  @change="updateData" />
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="appliedTos" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Applied To" id="input-" size="sm" :model.sync="model.appliedToId"  :selected="model.appliedTo != null ? model.appliedTo.name : ''" @input="getAppliedTos" @change="updateData" :loading="isAppliedToComboLoading"/>
					<app-input-combobox-autocomplete v-if="model.appliedToId == 'USER'" :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="User Name" id="input-" size="sm" :model.sync="model.userInfoUserName"  :selected="model.userInfo != null ? model.userInfo.FirstName : ''" @input="getUserInfos" @change="updateData" :loading="isUserInfoComboLoading"/>
					<app-input-combobox-autocomplete v-if="model.appliedToId == 'APPROVAL GROUP'" :options="approvalGroups" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Approval Group" id="input-" size="sm" :model.sync="model.approvalGroupId"  :selected="model.approvalGroup != null ? model.approvalGroup.name : ''" @input="getApprovalGroups" @change="updateData" :loading="isApprovalGroupComboLoading"/>
					<app-input-textbox v-if="model.appliedToId == 'USER LEVEL'" id="fieldset-user-level" label-cols-lg="12" type="number" label="User Level" label-for="input-user-level" size="sm" :model.sync="model.userLevel"  @change="updateData" />
					<b-row>
						<b-col>
							<b-form-group id="fieldset-is-partial-approval" label-cols-lg="8" label="Partial Approval" label-for="input-is-partial-approval">
								<b-form-checkbox id="input-is-partial-approval" v-model="model.usePartialApproval" @change="updateData"></b-form-checkbox>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group id="fieldset-is-sent-email" label-cols-lg="8" label="Is Send Email" label-for="input-is-sent-email">
								<b-form-checkbox id="input-is-sent-email" v-model="model.isSentEmail" @change="updateData"></b-form-checkbox>
							</b-form-group>
						</b-col>
						<b-col>
							<b-form-group id="fieldset-has-approval" label-cols-lg="8" label="Has Approval" label-for="input-has-approval">
								<b-form-checkbox id="input-has-approval" v-model="model.hasApproval" @change="updateData"></b-form-checkbox>
							</b-form-group>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</b-card>
		<div class="table-detail mt-4">
		<b-row class="mb-2">
			<b-col cols="9"><h5 class="card-title font-weight-bolder text-dark">Approval Configuration Detail</h5></b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="approvalConfigurationDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<b-row>
		<b-col>
			<app-table-input-popup :bordered="true" :items="approvalConfigurationDetails" :fields="fieldsApprovalConfigurationDetail" :busy="isDataLoading" :sort-by.sync="sortByApprovalConfigurationDetail" :sort-desc.sync="sortDescApprovalConfigurationDetail" small responsive
			@editButtonMethod="editRowDataApprovalConfigurationDetail"
			@deleteButtonMethod="deleteRowDataApprovalConfigurationDetail"
			@showPopupAddMethod="resetDataApprovalConfigurationDetail()"
			@showPopupUploadMethod="showPopupUploadApprovalConfigurationDetail()"
			@downloadMethod="downloadApprovalConfigurationDetail()"
			@addFromClipboardMethod="addFromClipboardApprovalConfigurationDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardApprovalConfigurationDetail()"
			:showActionButton="true"
			:showAddButton="true"
			:showDeleteButton="true"
			:showEditButton="true"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadApprovalConfigurationDetail"
			>
			<template v-slot:head(frontActions)>
				<div class="row justify-content-center">
					<b-button @click="isShowApprovalConfigurationDetailFilter = !isShowApprovalConfigurationDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
				</div>
			</template>
			<template #top-row v-if="isShowApprovalConfigurationDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Approver Type">
					<v-select append-to-body label="name" :options="approverTypes"  :value="filterApprovalConfigurationDetail.approverTypeId" :reduce="item => item.id" v-model="filterApprovalConfigurationDetail.approverTypeId" @search="getApproverTypes" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Approval Structure">
					<v-select append-to-body label="name" :options="approvalStructures"  :value="filterApprovalConfigurationDetail.approvalStructureId" :reduce="item => item.id" v-model="filterApprovalConfigurationDetail.approvalStructureId" @search="getApprovalStructures" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Approver Level">
					<b-form-input id="input-approver-level-table" v-model="filterApprovalConfigurationDetail.approverLevel" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approver User Name">
					<v-select append-to-body label="firstName" :options="userInfos" :value="filterApprovalConfigurationDetail.approverUserNameUserName" :reduce="item => item.userName" v-model="filterApprovalConfigurationDetail.approverUserNameUserName" @search="getUserInfos" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Stored Procedure Name">
					<b-form-input id="input-stored-procedure-name-table" v-model="filterApprovalConfigurationDetail.storedProcedureName" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approval Type">
					<b-form-input id="input-approval-type-table" v-model="filterApprovalConfigurationDetail.approvalType" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Configuration Content">
					<b-form-input id="input-configuration-content-table" v-model="filterApprovalConfigurationDetail.configurationContent" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Send Notification">
					<b-form-checkbox id="input-is-send-notification-table" class="float-right" v-model="filterApprovalConfigurationDetail.isSendNotification"></b-form-checkbox>
				</b-th>
				<b-th>
				</b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( approvalConfigurationDetailPageSize * (currentApprovalConfigurationDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
			<b-spinner class="align-middle text-primary"></b-spinner>
				<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(approvalConfiguration)="row">
				{{ row.item.approvalConfiguration != null ? row.item.approvalConfiguration.name : "" }}
			</template>
			<template v-slot:cell(approverType)="row">
				{{ row.item.approverType != null ? row.item.approverType.name : "" }}
			</template>
			<template v-slot:cell(approvalStructure)="row">
				{{ row.item.approvalStructure != null ? row.item.approvalStructure.name : "" }}
			</template>
			<template v-slot:cell(approverUserName)="row">
				{{ row.item.approverUserName != null ? row.item.approverUserName.firstName : "" }}
			</template>
				<template v-slot:form-add-detail>
				<ApprovalConfigurationDetailInput 
					:openPopup="isShowPopupApprovalConfigurationDetail"
					:modelId="approvalConfigurationDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataApprovalConfigurationDetail"/>
				</template>
				<template v-slot:upload-detail>
					<ApprovalConfigurationDetailUpload
					:openPopup="isShowPopupUploadApprovalConfigurationDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataApprovalConfigurationDetail"
					:parentId="modelId"
				 />
				</template>
			<template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentApprovalConfigurationDetailPage"
				:total-rows="totalApprovalConfigurationDetailRow"
				:per-page="approvalConfigurationDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template>
			</app-table-input-popup>
		</b-col>
		</b-row>
	</div>
		<PopupConfirmationDetail :openPopup="isShowPopupConfirmation" :modelId="modelId" @saveActionMethod="saveAction" @resetMethod="resetModal" />
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ApprovalConfiguration from '@/models/ApprovalConfiguration/ApprovalConfiguration';
import ApprovalConfigurationList from '@/models/ApprovalConfiguration/ApprovalConfigurationList';
import ApprovalConfigurationFilter from '@/filters/ApprovalConfiguration/ApprovalConfigurationFilter';

import PopupConfirmationDetail from './PopupConfirmationDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ApprovalType from '@/models/ApprovalType/ApprovalType';
import ApprovalTypeFilter from '@/filters/ApprovalType/ApprovalTypeFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppliedTo from '@/models/AppliedTo/AppliedTo';
import AppliedToFilter from '@/filters/AppliedTo/AppliedToFilter';
import ApprovalConfigurationDetail from '@/models/ApprovalConfiguration/ApprovalConfigurationDetail';
import ApprovalConfigurationDetailFilter from '@/filters/ApprovalConfiguration/ApprovalConfigurationDetailFilter';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
import ApprovalGroup from '@/models/ApprovalGroup/ApprovalGroup';
import ApprovalGroupFilter from '@/filters/ApprovalGroup/ApprovalGroupFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import ApprovalConfigurationDetailInput from '@/views/ApprovalConfiguration/ApprovalConfigurationDetailInput';
import ApprovalConfigurationDetailUpload from '@/views/ApprovalConfiguration/ApprovalConfigurationDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';

export default {
	components : {AppInputTextbox,AppInputComboboxAutocomplete,AppInputTextarea,ApprovalConfigurationDetailInput,ApprovalConfigurationDetailUpload,AppTableInput,AppTableInputPopup,PopupRouterView,PopupConfirmationDetail},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsApprovalConfigurationDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number"}}, 
				{"approverType": { "class" : "th-approver-type"}, "label" : "Approver Type", key: 'approverType', sortable: true}, 
				{"approvalStructure": { "class" : "th-approval-structure"}, "label" : "Approval Structure", key: 'approvalStructure', sortable: true}, 
				{"approverLevel": { "class" : "th-approver-level"}, "label" : "Approver Level", key: 'approverLevel', sortable: true}, 
				{"approverUserName": { "class" : "th-approver-user-name"}, "label" : "Approver User Name", key: 'approverUserName', sortable: true}, 
				{"storedProcedureName": { "class" : "th-stored-procedure-name"}, "label" : "Stored Procedure Name", key: 'storedProcedureName', sortable: true}, 
				{"approvalType": { "class" : "th-approval-type"}, "label" : "Approval Type", key: 'approvalType', sortable: true}, 
				{"configurationContent": { "class" : "th-configuration-content"}, "label" : "Configuration Content", key: 'configurationContent', sortable: true}, 
				{"isSendNotification": { "class" : "th-is-send-notification"}, "label" : "Is Send Notification", key: 'isSendNotification', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelApprovalConfigurationDetail : {},
			isShowPopupApprovalConfigurationDetail : false,
			isShowPopupUploadApprovalConfigurationDetail : false,
			filterApprovalConfiguration : null,
			currentApprovalConfigurationPage : 1,
			approvalConfigurationPageSize: 10,
			sortByApprovalConfiguration: '',
			sortDescApprovalConfiguration: '',
			filterApprovalConfigurationDetail : null,
			currentApprovalConfigurationDetailPage : 1,
			approvalConfigurationDetailPageSize: 10,
			sortByApprovalConfigurationDetail: '',
			sortDescApprovalConfigurationDetail: '',
			sortingByApprovalConfigurationDetail: [],
			approvalConfigurationDetails : [],
			approvalConfigurationDetailId : '',
			totalApprovalConfigurationDetailRow : 0,
			isShowApprovalConfigurationDetailFilter: false,
			isDownloadApprovalConfigurationDetail: false,
			approverTypes: [],
			approvalStructures: [],
			userInfos: [],
			approvalTypes: [],
			appliedTos: [],
			approvalGroups: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isApprovalComboLoading: false,
			isAppliedToComboLoading: false,
			isUserInfoComboLoading: false,
			isApprovalGroupComboLoading: false,
		}
	},
	methods : {
		getApprovalConfiguration : async function(id) {
			this.isBusy = true;
			ApprovalConfiguration.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadApprovalConfiguration = true;
			this.filterApprovalConfiguration.id = this.modelId;
			ApprovalConfiguration.downloadDataDetail(this, this.filterApprovalConfiguration).then(result => {
				this.isDownloadApprovalConfiguration = false;
			}).catch(error => { this.isDownloadApprovalConfiguration = false; })
		},
		getApprovalConfigurationDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterApprovalConfigurationDetail);
			if (this.modelId == null) return;
			filter.approvalConfigurationId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByApprovalConfigurationDetail != null && this.sortByApprovalConfigurationDetail!="") {
				this.sortingByApprovalConfigurationDetail[this.sortByApprovalConfigurationDetail] = this.sortDescApprovalConfigurationDetail;
			}else{
					this.sortingByApprovalConfigurationDetail["id"] = "1";
			}
			let currentPage = (this.currentApprovalConfigurationDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalApprovalConfigurationDetailRow + 1;
				let page = Math.ceil(totalData/this.approvalConfigurationDetailPageSize);
				currentPage = page - 1;
			}
			ApprovalConfigurationDetail.getList(this, filter, this.sortingByApprovalConfigurationDetail, currentPage , this.approvalConfigurationDetailPageSize).then(result => {
				this.currentApprovalConfigurationDetailPage = currentPage + 1;
				this.approvalConfigurationDetails = result.data;
				this.totalApprovalConfigurationDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getApprovalConfigurations : async function(input) {
			let filter = new ApprovalConfigurationFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalConfiguration.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurations = result.data
				}
			})
			.catch(error => {});
		},
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			if(this.filterApprovalConfigurationDetail.approvalStructureId != undefined && input == '')
			{
				filter.id = this.filterApprovalConfigurationDetail.approvalStructureId;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalGroups : async function(input) {
			let filter = new ApprovalGroupFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isApprovalGroupComboLoading = true;
			ApprovalGroup.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalGroups = result.data
				}
				this.isApprovalGroupComboLoading = false;
			})
			.catch(error => {this.isApprovalGroupComboLoading = false;});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			this.isUserInfoComboLoading = true;
			
			if(this.filterApprovalConfigurationDetail.approverUserNameUserName != undefined && input == '')
			{
				filter.userName = this.filterApprovalConfigurationDetail.approverUserNameUserName;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
				this.isUserInfoComboLoading = false;
			})
			.catch(error => {this.isUserInfoComboLoading = false;});
		},
		getApprovalTypes : async function(input) {
			let filter = new ApprovalTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isApprovalComboLoading = true;
			ApprovalType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalTypes = result.data
				}
				this.isApprovalComboLoading = false;
			})
			.catch(error => {this.isApprovalComboLoading = false;});
		},
		getAppliedTos : async function(input) {
			let filter = new AppliedToFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isAppliedToComboLoading = true;
			AppliedTo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.appliedTos = result.data
				}
				this.isAppliedToComboLoading = false;
			})
			.catch(error => {this.isAppliedToComboLoading = false;});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isShowPopupConfirmation = true;
			}
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					ApprovalConfiguration.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'approvalconfigurationindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					ApprovalConfiguration.insertData(this, model).then(result => {
						this.$router.push({ name: 'approvalconfigurationindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ApprovalConfiguration.updateData(this, model, id);
				}
			});
		},
		onHidden() {
			this.getApprovalConfigurations();
		},
		addRowDataApprovalConfigurationDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.approvalConfigurationId =  this.modelId;
					ApprovalConfigurationDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getApprovalConfigurationDetails(true);
						this.isShowPopupApprovalConfigurationDetail = false;
					})
				} else {
					model.approvalConfigurationId =  this.modelId;
					ApprovalConfigurationDetail.createDataDetail(this, model)
					.then(result => {
						this.getApprovalConfigurationDetails(true);
						this.isShowPopupApprovalConfigurationDetail = false;
					})
				}
			}
		},
		async editRowDataApprovalConfigurationDetail(id) {
			this.approvalConfigurationDetailId = id;
			this.isShowPopupApprovalConfigurationDetail = true; 
		},
		async deleteRowDataApprovalConfigurationDetail(id) {
			ApprovalConfigurationDetail.deleteData(this, id).then(result => { this.getApprovalConfigurationDetails(); });
		},
		async resetDataApprovalConfigurationDetail() {
			this.approvalConfigurationDetailId = "";
			this.isShowPopupApprovalConfigurationDetail = true;
		},
		async addDataApprovalConfigurationDetail() {
			ApprovalConfigurationDetail.createDataDetail(this, { approvalConfigurationId: this.modelId })
			.then(result => {
				this.getApprovalConfigurationDetails(true);
			})
		},
		async addFromClipboardApprovalConfigurationDetail() {
			let approverTypes = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					approverTypes.push({ approverType: item, approvalConfigurationId: this.modelId });
				});
				ApprovalConfigurationDetail.addFromClipboard(this, approverTypes).then(result => { this.getApprovalConfigurationDetails() });
			});
		},
		async replaceFromClipboardApprovalConfigurationDetail() {
			let approverTypes = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					approverTypes.push({ approverType: item, approvalConfigurationId: this.modelId });
				});
				ApprovalConfigurationDetail.replaceFromClipboard(this, approverTypes).then(result => { this.getApprovalConfigurationDetails() });
			});   
		},
		showPopupUploadApprovalConfigurationDetail() {
			this.isShowPopupUploadApprovalConfigurationDetail = true;
		},
		uploadDataApprovalConfigurationDetail(modalEvent, newDatas) {
			this.isShowPopupUploadApprovalConfigurationDetail = false; 
		},
		downloadApprovalConfigurationDetail(modalEvent) {
			this.isDownloadApprovalConfigurationDetail = true;
			this.filterApprovalConfigurationDetail.approvalConfigurationId = this.modelId;
			ApprovalConfigurationDetail.downloadDataDetail(this, this.filterApprovalConfigurationDetail).then(result => {
				this.isDownloadApprovalConfigurationDetail = false;
			}).catch(error => { this.isDownloadApprovalConfigurationDetail = false; })
		},
		saveInputApprovalConfigurationDetail(item) {
			ApprovalConfigurationDetail.updateDataDetail(this, item, item.id);
		},
		resetModal(modalType) {
			this.isShowPopupUploadApprovalConfigurationDetail = false; 
			this.isShowPopupApprovalConfigurationDetail = false; 
			if (modalType == 'ApprovalConfigurationDetail') {
				this.getApprovalConfigurationDetails();
			}

			// Tambahan agar di klik kedua tidak hilang
			this.approvalConfigurationDetailId = "";

			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowApprovalConfigurationDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterApprovalConfiguration = new ApprovalConfigurationFilter();
		this.filterApprovalConfigurationDetail = new ApprovalConfigurationDetailFilter();
		this.getApprovalConfigurations();
		this.getApproverTypes();
		this.getApprovalStructures();
		this.getUserInfos();
		this.getApprovalTypes();
		this.getAppliedTos();
		this.getApprovalGroups();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getApprovalConfiguration(id);
			} else {
				this.modelId = id;
				this.getApprovalConfiguration(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
		sortByApprovalConfigurationDetail : {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		sortDescApprovalConfigurationDetail: {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		currentApprovalConfigurationDetailPage: {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		approvalConfigurationDetailPageSize : {
			handler: function() {
				this.getApprovalConfigurationDetails();
			}
		},
		filterApprovalConfigurationDetail: {
			handler: function() {
				this.getApprovalConfigurationDetails();
			},
			deep: true,
		},
		// 'model.approverTypeId' : {
		// 	handler: function() {
		// 		console.log(this.model.storedProcedureName)
		// 		if(this.model.approverTypeId == 'APPROVAL STRUCTURE')
		// 		{
		// 			this.model.approverUserName = null;
		// 			this.model.storedProcedureName = null;
		// 			this.model.approverLevel = null;
		// 		}
		// 	}
			
		// }
	},
	beforeDestroy() {
		if (!this.isDataCommited) {
			//ApprovalConfiguration.discardData(this, this.modelId);
		}
	},
}
</script>
